
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./mixpanel.cjs.production.min.js')
} else {
  module.exports = require('./mixpanel.cjs.development.js')
}
